import type { FaireProductEntity } from "../../entity_types/product";

export const p_bcfm79puqz: FaireProductEntity = {
  token: "p_bcfm79puqz",
  type: "product",
  name: "Rad Grad Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/540b48e019cfe8594a845aaf5b80e3785fbe76cbd3060ecacf9c8d2896439fb3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3c0653b5d3c1b2ca39c9e7a446bf6c16dcb5fc7ca6eddf99c091534c12477d5b.jpeg",
    "https://cdn.faire.com/fastly/a5bf2514ea7a3069b1d40da45a1fb2a36bd2be2baec8f5b85941634b1151c686.jpeg",
    "https://cdn.faire.com/fastly/391c5ce5ab59bd650a6891bed7080c0c4dc2d9b1ce982c89cc5843ec8e043e9b.jpeg",
    "https://cdn.faire.com/fastly/967843b18e9437a3152b91998a1927051a72c39f4d08824a9067250d5f9c0348.jpeg",
    "https://cdn.faire.com/fastly/5c3da13b2a2f24765535c3e0ba8ea039492060622e53245f749328925e7d42a0.jpeg"
  ],
  priceDollars: 6.75,
  description: "If you're ready for these socks, you're ready to learn that nobody in the world requires cursive script, or knows algebra.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:36:32.789Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
